import { createSlice } from '@reduxjs/toolkit';
import { fetchAllFloridaChapters } from '../CommunityAPI/communityApi';

const fetchAllFloridaChaptersSlice = createSlice({
    name: 'fetchAllFloridaChapters',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchAllFloridaChapters cases
            .addCase(fetchAllFloridaChapters.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllFloridaChapters.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchAllFloridaChapters.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default fetchAllFloridaChaptersSlice.reducer;
